import React from 'react';
import { useIntl } from 'react-intl';

import { SMSProviders } from '../../../api';
import { SMS_LINKS } from '../../../constants';
import { FieldInput } from '../../ui';
import {
  DescriptionLink,
  FieldWrapper,
  ProviderSubtitle,
  ProviderTitle,
  SmsProviderFieldsCard,
  SmsProviderHeader
} from '../style';
import { SMSProviderStatus } from './SMSProviderStatus';
import { ProviderFieldProps } from './types';
import { maxFieldLength } from './validator';

export const SmsCenterFields = ({ errors, providerData }: ProviderFieldProps): JSX.Element => {
  const intl = useIntl();
  const { SMSCENTER_API } = SMS_LINKS;

  const getError = (field: string): string => {
    if (errors[SMSProviders.smscenter][field]) {
      return intl.formatMessage(
        { id: errors[SMSProviders.smscenter][field] as string },
        { number: maxFieldLength }
      );
    }

    return '';
  };

  return (
    <SmsProviderFieldsCard data-test-id="sms-provider-fields-card-smscenter">
      <SmsProviderHeader>
        <ProviderTitle>
          {intl.formatMessage({ id: 'custom-providers.settings.sms.provider.smscenter.label' })}
        </ProviderTitle>
        <SMSProviderStatus
          providerData={providerData}
          dataTestId="sms-provider-smscenter-status-button"
        />
      </SmsProviderHeader>
      <ProviderSubtitle>
        {intl.formatMessage(
          { id: 'custom-providers.settings.sms.provider.smscenter.description' },
          {
            a: (chunk: string) => (
              <DescriptionLink href={SMSCENTER_API} target="_blank">
                {chunk}
              </DescriptionLink>
            )
          }
        )}
      </ProviderSubtitle>
      <FieldWrapper>
        <FieldInput
          label={intl.formatMessage({
            id: 'custom-providers.settings.sms.provider.smscenter.app-id.label'
          })}
          errorMessage={getError('app_id')}
          name={`fields.${SMSProviders.smscenter}.app_id`}
        />
      </FieldWrapper>
      <FieldWrapper>
        <FieldInput
          label={intl.formatMessage({
            id: 'custom-providers.settings.sms.provider.smscenter.app-secret.label'
          })}
          errorMessage={getError('app_secret')}
          name={`fields.${SMSProviders.smscenter}.app_secret`}
        />
      </FieldWrapper>
      <FieldWrapper>
        <FieldInput
          label={intl.formatMessage({
            id: 'custom-providers.settings.sms.provider.smscenter.sender-id.label'
          })}
          errorMessage={getError('sender_id')}
          name={`fields.${SMSProviders.smscenter}.sender_id`}
        />
      </FieldWrapper>
    </SmsProviderFieldsCard>
  );
};
